/* eslint-disable quote-props */
export const oddsOfHittingTable = {
  '28': ['99', '99'],
  '27': ['98', '98'],
  '26': ['96', '98'],
  '25': ['94', '97'],
  '24': ['90', '95'],
  '23': ['86', '92'],
  '22': ['80', '90'],
  '21': ['74', '86'],
  '20': ['67', '82'],
  '19': ['60', '77'],
  '18': ['53', '73'],
  '17': ['46', '68'],
  '16': ['39', '62'],
  '15': ['33', '57'],
  '14': ['27', '52'],
  '13': ['22', '47'],
  '12': ['18', '43'],
  '11': ['15', '38'],
  '10': ['12', '34'],
  '9': ['09', '31'],
  '8': ['07', '27'],
  '7': ['06', '24'],
  '6': ['05', '21'],
  '5': ['04', '19'],
  '4': ['03', '17'],
  '3': ['02', '15'],
  '2': ['02', '13'],
  '1': ['01', '11'],
  '0': ['01', '10'],
  '-1': ['01', '09'],
  '-2': ['00', '08'],
  '-3': [false, '07'],
  '-4': [false, '06'],
  '-5': [false, '05'],
  '-6': [false, '04'],
  '-8': [false, '03'],
  '-10': [false, '02'],
  '-15': [false, '01'],
  '-17': [false, '00'],
  '-22': [false, false],
};
